module.exports = __webpack_public_path__ + "media/audio1.01092338.mp3";